import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Import helpers
import { createLinkParams, getTypeTranslation } from 'helpers';
import { PRODUCTS_TYPES } from 'helpers/variables';

const { SERIES, MOVIE } = PRODUCTS_TYPES;

const useDetailsButton = ({ uuid, subtype, redirect, title, GTMEvent }) => {
	const ref = useRef();
	const { t } = useTranslation();
	const buttonText = t('vod_buttons_play');

	const { pathname } = useLocation();
	const isEpisode = pathname.split('/').includes(getTypeTranslation(SERIES));

	const type = isEpisode ? SERIES : MOVIE;
	const linkRedirect = subtype
		? createLinkParams({ id: uuid, type: subtype, title })
		: `/vod/ogladaj/${getTypeTranslation(type)}/${uuid}`;

	const handleRedirect = () => {
		GTMEvent({ linkRedirect, pathname, label: buttonText });
		redirect();
	};

	return {
		ref,
		handleRedirect,
		buttonText,
		linkRedirect
	};
};

export default useDetailsButton;
